import type { PermissionAction } from '../types';

/** Resource IDs for scheduler app (seed in fbt_ref.permission_resource). */
export const SCHEDULER_RESOURCES = {
  module: 'scheduler',
  dashboard: 'scheduler.dashboard',
  dashboardOverview: 'scheduler.dashboard.overview',
  dashboardReports: 'scheduler.dashboard.reports',
  schedule: 'scheduler.schedule',
  scheduleImport: 'scheduler.schedule.import',
  scheduleLocations: 'scheduler.schedule.locations',
  scheduleTasks: 'scheduler.schedule.tasks',
  scheduleBaselines: 'scheduler.schedule.baselines',
  scheduleCalendar: 'scheduler.schedule.calendar',
} as const;

export type SchedulerResourceId =
  (typeof SCHEDULER_RESOURCES)[keyof typeof SCHEDULER_RESOURCES];

/** Sidebar / route → resource + action for nav visibility */
export interface SchedulerNavPermission {
  resourceId: SchedulerResourceId | string;
  action: PermissionAction;
}

export const SCHEDULER_NAV_PERMISSIONS = {
  dashboardOverview: {
    resourceId: SCHEDULER_RESOURCES.dashboardOverview,
    action: 'view' as PermissionAction,
  },
  dashboardReports: {
    resourceId: SCHEDULER_RESOURCES.dashboardReports,
    action: 'view' as PermissionAction,
  },
  /** Alias — same resource as dashboardReports for the Reports hub. */
  reportsLocationHealth: {
    resourceId: SCHEDULER_RESOURCES.dashboardReports,
    action: 'view' as PermissionAction,
  },
  scheduleImport: {
    resourceId: SCHEDULER_RESOURCES.scheduleImport,
    action: 'view' as PermissionAction,
  },
  scheduleLocations: {
    resourceId: SCHEDULER_RESOURCES.scheduleLocations,
    action: 'view' as PermissionAction,
  },
  scheduleTasks: {
    resourceId: SCHEDULER_RESOURCES.scheduleTasks,
    action: 'view' as PermissionAction,
  },
  scheduleBaselines: {
    resourceId: SCHEDULER_RESOURCES.scheduleBaselines,
    action: 'view' as PermissionAction,
  },
  scheduleCalendar: {
    resourceId: SCHEDULER_RESOURCES.scheduleCalendar,
    action: 'view' as PermissionAction,
  },
} as const satisfies Record<string, SchedulerNavPermission>;

export type SchedulerNavKey = keyof typeof SCHEDULER_NAV_PERMISSIONS;
